import * as React from 'react';
import {useState} from "react";
import {hasErrors, validate} from "../helpers/validation";
import styled from "styled-components";
import {COLOR, FONT_SIZE} from "../themes";
import {Input} from "./Input";
import {Modal} from "./Modal";
import {subscribeEmail} from "../api/apiService";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const nameRegex = /^[\p{L}]+$/u;
const modalTitle = 'Subscribe to our email feed';
const modalSubtitle = 'To stay in touch with our recent dev updates'

const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 100%;
  font-size: ${FONT_SIZE.md};
  font-weight: 700;
  color: ${COLOR.white};
  background-color: ${({ $isActive }) => $isActive ? COLOR.gold : COLOR.gray};
  border-radius: 4px;
  cursor: pointer;
`;

export const EmailSubscribe = ({setIsEmailModalOpen}) => {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [errors, setErrors] = useState({ email: [], name: [] });
    const [isDirty, setIsDirty] = useState(false);

    const onChangeEmail = (value) => {
        setEmail(value);

        const emailErrors = validate({ email: value }, 
            { email: { match: { value: emailRegex, message: 'Please enter valid email' } } })?.email;
        setErrors((prev) => ({ ...prev, email: emailErrors || [] }));
        setIsDirty(true);
    }

    const onChangeName = (value) => {
        setName(value);

        const nameErrors = validate({ name: value }, 
            { name: { min: { value: 1, message: 'Please enter at least 1 letter' }, 
                match: { value: nameRegex, message: 'Name contains invalid characters' } } })?.name;
        
        setErrors((prev) => ({ ...prev, name: nameErrors || [] }));
        setIsDirty(true);
    }
    
    return (
        <Modal title={modalTitle} subtitle={modalSubtitle} onClose={() => setIsEmailModalOpen(false)}>
            <Input
                type='email'
                label='Email'
                placeholder='alt@namethinkergames.com'
                value={email}
                onChange={onChangeEmail}
                errors={errors.email}
            />
            <Input
                label='Name'
                placeholder='Alt'
                value={name}
                onChange={onChangeName}
                errors={errors.name}
            />
            <Button $isActive={(!hasErrors(errors) && isDirty) && name && email} onClick={() => { subscribeEmail(email, name) }}>
                CONFIRM
            </Button>
        </Modal>
    );
};